import { applyMiddleware, compose, createStore } from "redux";
import { loadState, saveState } from "./persister/localStorage";
import rootReducer from "./rootReducer";
import thunk from "redux-thunk";

export default (initialState = loadState()) => {
  // Middleware you want to use in development:
  const enhancers = [];

  // Required! Enable Redux DevTools with the monitors you chose
  const devToolsExtension = window.devToolsExtension;
  if (typeof devToolsExtension === "function" && process.env.NODE_ENV !== "production") {
    enhancers.push(devToolsExtension());
  }

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/reactjs/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, compose(applyMiddleware(thunk), ...enhancers));

  store.subscribe(() => {
    saveState({
      cart: store.getState().cart
    });
  });

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (module.hot) {
    module.hot.accept("./rootReducer", () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/app/redux/createStore.js